import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { TaskProvider } from "./components/organisms/Provider";
import { GlobalErrorBoundary } from "./components/organisms/ErrorBoundary";
import "./_metronic/assets/fonticon/fonticon.css";
import "./_metronic/assets/keenicons/duotone/style.css";
import "./_metronic/assets/keenicons/outline/style.css";
import "./_metronic/assets/keenicons/solid/style.css";
import "./_metronic/assets/sass/style.scss";
import "./_metronic/assets/sass/plugins.scss";
import "./_metronic/assets/sass/style.react.scss";
import "react-toastify/dist/ReactToastify.css";
import "react-datetime/css/react-datetime.css";
import "./assets/css/common.css";
import { AppRoutes } from "./routes/AppRoutes";
import PortalAppRoot from "./app/b2bPortal/PortalAppRoot";

const isPortalRoute = window.location.pathname.startsWith("/portal");

const container = document.getElementById("root");
if (container) {
  createRoot(container).render(
    <React.StrictMode>
      <GlobalErrorBoundary>
        <Provider store={store}>
          <TaskProvider>{isPortalRoute ? <PortalAppRoot /> : <AppRoutes />}</TaskProvider>
        </Provider>
      </GlobalErrorBoundary>
    </React.StrictMode>,
  );
}
